// extracted by mini-css-extract-plugin
module.exports = {"plan-info-wrapper":"_3qLQF","plan-info":"_2ddKu","plan-title":"_2SFtd","plan-value":"_1fMKg","plan-info-download":"_229hn"};